import { NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'app-visualizer-item',
  standalone: true,
  templateUrl: './visualizer-item.component.html',
  styleUrls: ['./visualizer-item.component.scss'],
  imports: [NgIf, TranslateModule]
})
export class VisualizerItemComponent {
  @Input() imageUrl: string;
  @Input() title: string;
  @Input() description: string;
  @Input() link: string;
}
